/** * Created by lobin on 2019/1/15. */
<template>
  <div class="myresume-box">
    <div class="myresume contentWidth">
      <!-- <div class="flex myresume-search">
        <Search :isPosition="false" :isHot="false" @updateValue="updateValue"></Search>
        <div class="boxShadow weichat flex"> 
          <p>扫码进入<br/>小程序</p>
          <img src="" alt="" >
          <div class="lines"></div>
        </div>
      </div> -->
      <div class="myresume-wraper flexBetween clearfix" id="affix-content">
          
          <!-- 目录 -->
          <div class="myresume-aside  myresume-directory boxShadow" style="width: 192px;">
              <div class="myresume-aside-progress">
                <div class="myresume-aside-progress-text">简历目录</div>
              </div>
              <div class="myresume-aside-stepmenu">               
                <scrollactive class="myresume-aside-stepmenu-content" :offset="0">
                  <a v-for="item in hrefList" :key="item.id"
                   :href="item.href" 
                   :title="item.title" 
                   class="scrollactive-item">{{item.name}}</a>
                </scrollactive>
              </div>
          </div>
          <!-- 简历 -->
          <div class="myresume-main boxShadow ">
            <h2 class="myresume-main-title">在线简历</h2>
            <!-- 基本信息 -->
            <div class="myresume-main-content bottomBorder" id="baseinfo">
              <h3 class="myresume-content-item-title border-left flexBetween" >
                <div class="base flex"> 
                  <img style="width: 24px;height: 24px; margin-right: 10px;" src="../../assets/images/newicon/icons/resumeIcon.png"/> 
                  基本信息</div>
                
                <span class="edit" @click="baseInfoEditAction" v-if="!baseInfoEdit">
                  <i class="el-icon-edit"></i>编辑
                </span>
              </h3>
              <!-- 展示基本信息 -->
              <div class="myresume-baseinfo clearfix flex " v-if="!baseInfoEdit">
                <div class="myresume-baseinfo-right">
                  <img :src="baseInfo.imageUrl || defaultAvatar" class="avatar" />
                </div>
                <div class="myresume-baseinfo-left">
                  <div class="myresume-baseinfo-item info" v-if="baseInfo">
                    <div class="myresume-baseinfo-item-seekerName">{{ baseInfo.jobSeekerName}}</div>
                    <el-row style="margin-top: 10px;">
                     
                        <el-tooltip
                          v-if="baseInfo.genderDisplay"
                          effect="light"
                          content="性别"
                          placement="top-start"
                          :enterable="false">
                          <a>{{ baseInfo.genderDisplay}}</a>
                        </el-tooltip>

                        <el-divider v-if="baseInfo.age" direction="vertical"></el-divider>
                        <el-tooltip
                          v-if="baseInfo.age"
                          effect="light"
                          content="年龄"
                          placement="top-start"
                          :enterable="false">
                          <a>{{ baseInfo.age}} 岁</a>
                        </el-tooltip>
                        
                      <el-divider direction="vertical" v-if="baseInfo.graduateSchool"></el-divider>
                      <el-tooltip
                        effect="light"
                        content="毕业学校"
                        placement="top-start"
                        :enterable="false">
                        <a v-if="baseInfo.graduateSchool">
                          <i
                            class="el-icon-school"
                            style="color: #333;margin-right:5px;"></i>{{ baseInfo.graduateSchool }}
                        </a>
                      </el-tooltip>
                      
                      <el-divider v-if="baseInfo.currentAreaId" direction="vertical"></el-divider>
                      <el-tooltip
                        effect="light"
                        content="所在城市"
                        placement="top-start"
                        :enterable="false">
                        <a v-if="baseInfo.currentAreaId">{{ baseInfo.currentAreaId }}</a>
                      </el-tooltip>

                      <el-divider v-if="baseInfo.workExperience" direction="vertical"></el-divider>
                      <a v-if='baseInfo.workExperience'> 工作 {{ baseInfo.workExperience }} 年</a>
                    </el-row>

                    <el-row style="margin-top: 10px;">
                      <el-tooltip
                        effect="light"
                        content="手机号"
                        placement="top-start"
                        :enterable="false"
                      >
                        <a v-if="baseInfo.phone">
                          <i class="fonticon">&#xe6a9;</i>{{ baseInfo.phone }}
                        </a>
                      </el-tooltip>

                      <el-divider direction="vertical" v-if="baseInfo.jobSeekerWechatId"></el-divider>
                      <el-tooltip
                        effect="light"
                        content="微信号"
                        placement="top-start"
                        :enterable="false"
                      >
                        <a v-if="baseInfo.jobSeekerWechatId">
                          <i class="fonticon">&#xe602;</i
                          >{{ baseInfo.jobSeekerWechatId }}
                        </a>
                      </el-tooltip>

                      <el-divider direction="vertical" v-if="baseInfo.email"></el-divider>
                      <el-tooltip
                        effect="light"
                        content="邮箱号"
                        placement="top-start"
                        :enterable="false"
                      >
                        <a v-if="baseInfo.email">
                          <i class="fonticon">&#xe69f;</i>{{ baseInfo.email }}
                          <!-- <el-button
                            type="danger"
                            plain
                            round
                            size="mini"
                            @click="checkEmail"
                            v-if="!baseInfo.emailValidate"
                            >未验证</el-button
                          >
                          <el-button size="mini" round v-else type="success"
                            >已验证</el-button
                          > -->
                        </a>
                      </el-tooltip>
                    </el-row>
                  </div>
                </div>
                
              </div>
              <!-- 编辑基本信息 -->
              <div class="myresume-baseinfo clearfix" v-else>
                <el-form
                  :model="baseInfo"
                  :rules="baseInforules"
                  ref="baseInfo"
                  label-width="100px"
                  class="myresume-form"
                >
                  <el-row :gutter="20">
                    <el-col :span="18">
                      <el-row :gutter="20">
                        <el-col :span="20">
                          <el-form-item label="姓名" prop="jobSeekerName"
                            ><el-input
                              v-model="baseInfo.jobSeekerName"
                              placeholder="请输入姓名"
                            ></el-input
                          ></el-form-item>
                        </el-col>
                        <el-col :span="20">
                          <el-form-item label="性别" prop="gender">
                            <el-select
                              v-model="baseInfo.gender"
                              placeholder="请选择"
                              clearable
                            >
                              <el-option
                                v-for="item in gender"
                                :key="item.code"
                                :label="item.name"
                                :value="item.code"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                        </el-col>
                        <el-col :span="20">
                          <el-form-item label="出生年月" prop="birthday">
                            <el-date-picker
                              type="month"
                              placeholder="选择日期"
                              v-model="baseInfo.birthday"
                              :picker-options="pickerOptionsEnd"
                              style="width: 100%;"
                              value-format="yyyy-MM-dd"
                              @change="dateChange"
                            ></el-date-picker>
                          </el-form-item>
                        </el-col>
                        <el-col :span="20">
                          <el-form-item label="手机号" prop="phone">
                            <el-input
                              v-model="baseInfo.phone"
                              placeholder="请输入手机号"
                            ></el-input></el-form-item>
                        </el-col>
                        <el-col :span="20">
                          <el-form-item label="微信号" prop="jobSeekerWechatId">
                            <el-input
                              v-model="baseInfo.jobSeekerWechatId"
                              placeholder="请输入微信号">
                            </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="20">
                          <el-form-item label="邮箱" prop="email">
                            <el-input
                              v-model="baseInfo.email"
                              placeholder="请输入邮箱">
                            </el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>

                    <el-col :span="6" class="avatar-edit" >
                      <el-form-item label="" :label-width="'0px'">
                        <el-upload
                          class="avatar-uploader"
                          :action="attachmentsUrl"
                          :show-file-list="false"
                          :headers="{ token: token }"
                          :on-success="handleAvatarSuccess"
                          :before-upload="beforeAvatarUpload"
                        >
                          <!-- <img
                            :src="baseInfo.imageUrl || defaultAvatar"
                            class="avatar"
                          /> -->
                          <el-image
                          class="avatar"
                          style="width: 135px; height: 135px;"
                          :src="baseInfo.imageUrl || defaultAvatar"
                          :fit="'fill'"></el-image>
                          <!-- 一键上传 -->
                          <i class="fonticon">&#xe638;</i>
                          <p class="avatar-title">上传照片</p>
                        </el-upload>
                      </el-form-item>
                    </el-col>

                    <el-col :span="15">
                      <el-form-item label="毕业学校" prop="graduateSchool">
                        <el-input
                          v-model="baseInfo.graduateSchool"
                          placeholder="请输入毕业学校"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="15">
                      <el-form-item label="最高学历" prop="qualificationsType">
                        <el-select
                          v-model="baseInfo.qualificationsType"
                          placeholder="请选择最高学历"
                        >
                          <el-option
                            :label="item.name"
                            v-for="item in qualificationsType"
                            :key="item.code"
                            :value="item.code"
                            >{{ item.name }}</el-option
                          >
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="15">
                      <el-form-item label="专   业" prop="majorSubjects">
                        <el-input
                          v-model="baseInfo.majorSubjects"
                          placeholder="请输入最高学历所学专业"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="15">
                      <el-form-item label="毕业时间" prop="graduateDate">
                        <el-date-picker
                          type="month"
                          placeholder="选择日期"
                          v-model="baseInfo.graduateDate"
                          :picker-options="pickerOptionsEnd"
                          style="width: 100%;"
                          value-format="yyyy-MM"
                        ></el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="15">
                      <el-form-item label="当前公司" prop="currentCompany"
                        ><el-input
                          v-model="baseInfo.currentCompany"
                          placeholder="请输入当前就职公司"
                        ></el-input
                      ></el-form-item>
                    </el-col>
                    <el-col :span="15">
                      <el-form-item label="目前职位" prop="positionName">
                        <el-input
                          v-model="baseInfo.positionName"
                          placeholder="请输入目前职位"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="15">
                      <el-form-item label="所在城市" prop="currentAreaId"
                        ><el-input
                          v-model="baseInfo.currentAreaId"
                          placeholder="请输入当前所在城市"
                        ></el-input
                      ></el-form-item>
                    </el-col>
                    <el-col :span="24" style="text-align: center">
                      <el-button @click="cancelBaseInfoEdit">取消</el-button>
                      <el-button type="primary" @click="modifyBaseInfo"
                        >保存</el-button
                      >
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
            <!-- 个人标签 -->
            <div class="myresume-main-content bottomBorder" id="IndividualLabels">
              <h3 class="myresume-content-item-title border-left flexBetween">
                <div class="flex">
                  <img style="width: 24px;height: 24px; margin-right: 10px;" src="../../assets/images/newicon/icons/resumeIcon.png"/> 
                  个人标签
                </div>
                
                <span
                  class="edit"
                  @click="resetEdit();ndividualLabelsiEdit = true;"
                  v-if="!ndividualLabelsiEdit"><i class="el-icon-edit"></i>编辑</span>
              </h3>
              <div class="myresume-edit-content" v-if="ndividualLabelsiEdit">
                <el-select
                  v-model="ndividualLabels"
                  multiple
                  filterable
                  allow-create
                  :multiple-limit="3"
                  default-first-option
                  popper-class="person-labels"
                  placeholder="请选择个人标签"
                >
                </el-select>
                <ul class="person-labels-sets clearfix">
                  <li
                    v-for="(item, index) in personlabels"
                    :key="index"
                    @click="choosePersonLabels(item)">
                    {{ item.value }}
                  </li>
                </ul>
                <div style="text-align: center;margin-top: 0;" class="person-labels-sets">
                  <el-button @click="ndividualLabelsCancel">取消</el-button>
                  <el-button type="primary" @click="addLabelsAction">保存</el-button>
                </div>
              </div>
              <div class="myresume-edit-content" v-else>
                <el-tag
                  size="medium"
                  v-for="(item, index) in ndividualLabels"
                  :key="index"
                  >{{ item }}</el-tag
                >
              </div>
            </div>
            <!-- 自我评价 -->
            <div class="myresume-main-content bottomBorder" id="selfEvaluation">
              <h3 class="myresume-content-item-title border-left flexBetween">
                <div class="flex">
                  <img style="width: 24px;height: 24px; margin-right: 10px;" src="../../assets/images/newicon/icons/resumeIcon.png"/> 
                  自我评价
                </div>
                <span
                  class="edit"
                  @click="
                    resetEdit();
                    selfEvaluationEdit = true;
                  "
                  v-if="!baseInfoEdit"
                  ><i class="el-icon-edit"></i>编辑</span
                >
              </h3>
              <div
                style="font-size: 14px;line-height: 2"
                v-html="baseInfo.personalAdvantage"
                v-if="!selfEvaluationEdit"
              ></div>
              <div class="myresume" v-if="selfEvaluationEdit">
                <quill-editor
                  v-model="baseInfo.personalAdvantage"
                  ref="myQuillEditor"
                >
                </quill-editor>
                <div style="text-align: center;margin-top: 20px">
                  <el-button @click="cancelSelfEvaluationEdit">取消</el-button>
                  <el-button type="primary" @click="modiySelfEvaluation"
                    >保存</el-button
                  >
                </div>
              </div>
            </div>

            <!-- 求职意向 -->
            <div class="myresume-main-content bottomBorder" id="jobIntention">
              <h3 class="myresume-content-item-title border-left flexBetween">
                <div class="flex">
                  <img style="width: 24px;height: 24px; margin-right: 10px;" 
                    src="../../assets/images/newicon/icons/resumeIcon.png"/> 
                  求职意向
                </div>
                <span class="edit"
                  @click="addJobExpectList('new')"
                  v-if="JobExpectateList.length < 5">
                  <i class="el-icon-circle-plus-outline"></i>&nbsp;添加</span>
              </h3>
              <div
                class="myresume-edit"
                @click="addJobExpectList('new')"
                v-if="JobExpectateList.length === 0">
                添加求职意向
              </div>
              <div v-for="(item, index) in JobExpectateList" :key="index">
                <div class="myresume-content-ls" v-if="!JobExpectateEdit[index]">

                  <h2 class="myresume-content-ls_title">{{ item.desirePositionTypeName}}</h2>
                  <div class="myresume-content-ls_stitle flex">
                     <div style="width: 50%;" class="jobExpectText">
                      <p>薪资要求：{{ item.desireSalaryMin}}-{{ item.desireSalaryMax }} K/月</p>
                      <p>工作性质：{{item.jobHuntTypeName}} </p>
                     </div>
                     <div class="jobExpectText">
                      <p>期望城市：{{item.desireCityName}} </p>
                      <p>期望行业：{{item.desireIndustryName}} </p>
                     </div>
                  </div>
                  <div class="edit-tools">
                    <i
                      class="el-icon-edit"
                      @click="changeEditStatu('JobExpectateEdit', index)"
                    ></i>
                    <i
                      class="el-icon-delete"
                      @click="deleteItem('delJobExpect', item.id)"
                    ></i>
                  </div>
                </div>
                <jobExpectEdit
                  :type="JobExpectateStatus"
                  v-if="JobExpectateEdit[index]"
                  cancelText="取消"
                  v-model="JobExpectateList[index]"
                  :index="index"
                  @submit="jobExpectEditSuc"
                />
              </div>
            </div>

            <!-- 工作经历 -->
            <div class="myresume-main-content bottomBorder" id="workExperience">
              <h3 class="myresume-content-item-title border-left flexBetween">
                <div class="flex">
                  <img style="width: 24px;height: 24px; margin-right: 10px;" src="../../assets/images/newicon/icons/resumeIcon.png"/> 
                  工作经历
                </div>
                
                <span
                  class="edit"
                  @click="addWorkExperienceList('new')"
                  v-if="workExperienceList.length != 0">
                  <i class="el-icon-circle-plus-outline"></i>添加</span>
              </h3>
              <div
                class="myresume-edit"
                @click="addWorkExperienceList('new')"
                v-if="workExperienceList.length === 0">
                添加工作经历
              </div>
              <div
                v-for="(item, index) in workExperienceList"
                :key="index"
                ref="workExperienceList">
                <div class="myresume-content-ls" v-if="!workEdit[index]">
                  <h2 class="myresume-content-ls_title">{{ item.companyName }}
                    <span>{{ item.startDate }} -
                      {{
                        item.endDatePreviewDisplay == "1970-01"? "至今": item.endDatePreviewDisplay
                      }}</span>
                  </h2>
                  <div class="myresume-content-ls_stitle">
                    {{ item.positionName }}({{ item.positionTypeDisplay }})
                    <el-divider v-if="item.workAreaId" direction="vertical"></el-divider>
                    <span> {{ item.workAreaId }}</span>
                  </div>
                  <div class="flex">
                    <h3 class="shrink">工作内容：</h3>
                    <p class="myresume-content-ls_content" v-html="item.workContent"></p>
                  </div>
                  <div class="flex">
                      <h3 class="shrink">主要业绩：</h3>
                      <p class="myresume-content-ls_content" v-html="item.achievement"></p>
                  </div>
                  <div class="edit-tools">
                    <i class="el-icon-edit" @click="changeEditStatu('workEdit', index)"></i>
                    <i class="el-icon-delete" @click="deleteItem('delWorkExperience', item.id)"></i>
                  </div>
                </div>
                <wordEdit
                  :type="workEditStatus"
                  cancelText="取消"
                  v-if="workEdit[index]"
                  v-model="workExperienceList[index]"
                  :index="index"
                  @submit="workEditSuc"
                />
              </div>
            </div>

            <!-- 项目经验 -->
            <div class="myresume-main-content bottomBorder " id="projectExperience">
              <h3 class="myresume-content-item-title border-left flexBetween">
                <div class="flex">
                  <img style="width: 24px;height: 24px; margin-right: 10px;" src="../../assets/images/newicon/icons/resumeIcon.png"/> 
                  项目经验
                </div>
                <span
                  class="edit"
                  @click="addProjectExperienceList('new')"
                  v-if="projectExperienceList.length != 0">
                  <i class="el-icon-circle-plus-outline"></i>添加
                </span>
              </h3>
              <div
                class="myresume-edit"
                @click="addProjectExperienceList('new')"
                v-if="projectExperienceList.length === 0">
                添加项目经验
              </div>
              <div v-for="(item, index) in projectExperienceList" :key="index">
                <div class="myresume-content-ls" v-if="!projectEdit[index]">
                  <h2 class="myresume-content-ls_title">
                    {{ item.projectName }}
                    <span>
                      {{ item.projectStartDate }} -
                      {{
                        item.projectEndDatePreviewDisplay == "1970-01"
                          ? "至今"
                          : item.projectEndDatePreviewDisplay
                      }}</span
                    >
                  </h2>
                  <div class="myresume-content-ls_stitle">
                    {{ item.projectRole }}
                  </div>
                  <div class="flex">
                  <h3 class="shrink">项目描述：</h3>
                  <p
                    class="myresume-content-ls_content"
                    v-html="item.projectDescription"
                  ></p>
                </div>
                <div class="flex">
                  <h3 class="shrink">项目职责：</h3>
                  <p class="myresume-content-ls_content" v-html="item.projectDuty"></p>
                </div>
                <div class="flex" v-if="item.achievement">
                  <h3 class="shrink">使用技术栈：</h3>
                  <p class="myresume-content-ls_content" v-html="item.achievement"></p>
                </div>
                  <div class="edit-tools">
                    <i  class="el-icon-edit" @click="changeEditStatu('projectEdit', index)"></i>
                    <i class="el-icon-delete" @click="deleteItem('delProjectExperience', item.id)"></i>
                  </div>
                </div>
                <projectEdit
                  :type="projectEditStatus"
                  v-if="projectEdit[index]"
                  cancelText="取消"
                  v-model="projectExperienceList[index]"
                  :index="index"
                  @submit="projectEditSuc"
                />
              </div>
            </div>

            <!-- 教育经历 -->
            <div class="myresume-main-content" id="educationalExperience">
              <h3 class="myresume-content-item-title border-left flexBetween">
                <div class="flex">
                  <img style="width: 24px;height: 24px; margin-right: 10px;" src="../../assets/images/newicon/icons/resumeIcon.png"/> 
                  教育经历
                </div>
                <span
                  class="edit"
                  @click="addEducationalBackgroundList('new')"
                  v-if="educationalBackgroundList.length != 0"
                  ><i class="el-icon-circle-plus-outline"></i>&nbsp;添加</span
                >
              </h3>
              <div
                class="myresume-edit"
                @click="addEducationalBackgroundList('new')"
                v-if="educationalBackgroundList.length === 0">
                添加教育经历
              </div>
              <div v-for="(item, index) in educationalBackgroundList" :key="index">
                <div class="myresume-content-ls" v-if="!educationalEdit[index]">
                  <h2 class="myresume-content-ls_title">
                    {{ item.schoolName
                    }}{{
                      item.schoolTypeDisplay ? `(${item.schoolTypeDisplay})` : ""
                    }}
                    <span> {{ item.startTime }} - {{ item.endTime }}</span>
                  </h2>
                  <div class="myresume-content-ls_stitle">
                    {{ item.qualificationsTypeDisplay}} &nbsp;&nbsp;| &nbsp;&nbsp;{{ item.majorSubjects }}
                    <span v-if="item.unified !== null"> &nbsp;&nbsp;| &nbsp; &nbsp;{{ item.unified ? "统招" : "非统招" }}</span>
                  </div>
                  <div class="edit-tools">
                    <i
                      class="el-icon-edit"
                      @click="changeEditStatu('educationalEdit', index)"
                    ></i>
                    <i
                      class="el-icon-delete"
                      @click="deleteItem('delEducation', item.id)"
                    ></i>
                  </div>
                </div>
                <educationEdit
                  :type="educationalEditStatus"
                  v-if="educationalEdit[index]"
                  cancelText="取消"
                  v-model="educationalBackgroundList[index]"
                  :index="index"
                  @submit="educationEditSuc"
                />
              </div>
            </div>
          </div>
          
          <!-- 简历管理 -->
          <div>
            <!-- 上传附件简历 -->
            <div class="myresume-aside myresume-aside-attachement boxShadow">
              <h2 class="myresume-aside-attachement_title" v-if="attResumeList.length > 0">
                  <span>附件简历</span>
                  <el-upload 
                    class="upload-demo" 
                    style="display: inline-block;float:right"
                    :show-file-list="false"
                    :on-progress="uploadResumeProgress"
                    :on-success="uploadResumeAction"
                    :action="$store.state.uploadAttachementResume"
                    :headers="{ token: token }">
                    <el-button type="text" style="float: right;padding: 0" 
                      v-if="attResumeList.length < 2">添加
                    </el-button>
                  </el-upload>
              </h2>
              <!-- 仅用于无基本信息时按钮点击后提示完善基本信息 -->
              <div v-if="!baseInfo.jobSeekerName" style="text-align: center">
                  <div class="flex myresume-aside-uploadresume-title"> 
                    <img src="../../assets/images/newicon/icons/import.png"/>
                    <p>上传附件简历</p>
                  </div>
                  <!-- <p class="myresume-aside-uploadresume-subtitle">一键更新在线简历</p> -->
                  <p class="myresume-aside-uploadresume-desc"   
                    v-if="attResumeList.length === 0">
                    请上传DOC、DOCX、PDF格式的中文简历，大小不超过20M
                  </p>
                  <div class="myresume-aside-uploadresume-btn" @click="basicInfoTips">一键上传</div>
              </div>
              <template v-else>
                  <el-upload
                    class="upload-demo"
                    style="width: 100%"
                    :show-file-list="false"
                    :on-progress="uploadResumeProgress"
                    :on-success="uploadResumeAction"
                    :before-upload="beforeUploadAction"
                    :action="$store.state.uploadAttachementResume"
                    :headers="{ token: token }"
                    v-if="attResumeList.length == 0">
                    <div class="flex myresume-aside-uploadresume-title"> 
                      <img src="../../assets/images/newicon/icons/import.png"/>
                      <p>上传附件简历</p>
                    </div>
                    <!-- <p v-if="attResumeList.length == 0" class="myresume-aside-uploadresume-subtitle">一键更新在线简历</p> -->
                    <p v-if="attResumeList.length == 0" class="myresume-aside-uploadresume-desc">请上传DOC、DOCX、PDF格式的中文简历，大小不超过20M</p>
                    <div class="myresume-aside-uploadresume-btn">一键上传</div>
                  </el-upload>
                  <div v-else>
                    <!-- 模拟一个滚动条 -->
                    <el-progress :percentage="uploadProgress" v-if="showUploadProgress"></el-progress>
                    <ul class="myresume-aside-attachement_list">
                        <li class="myresume-aside-attachement_item flexBetween" v-for="item in attResumeList" :key="item.id">
                          <a :href="item.fileUrl"
                              style="margin-left: 10px;width: 160px;text-overflow: ellipsis;overflow: hidden;display: inline-block;white-space: nowrap;"
                          >{{ item.fileName }}</a>
                          <img  @click="deleteAttReume(item.id)" src="../../assets/images/newicon/icons/delete.png" style="width: 16px;height: 16px;cursor: pointer;"/>
                        </li>
                    </ul>
                  </div>
              </template>
            </div>
            <!--一句话兜售自己-->
            <div style="margin-top: 20px;width: 240px;">
                <a href="/myintro">
                  <img :src="talentImg" width="100%" />
                </a>
            </div>
            <!-- 解析生成在线简历 -->
            <div class="myresume-aside boxShadow" style="margin-top: 20px;">
              <div class="myresume-aside-uploadresume">
                  <div class="flex myresume-aside-uploadresume-title"> 
                    <img src="../../assets/images/newicon/icons/analysis.png"/>
                    <p>解析生成在线简历</p>
                  </div>
                  <p class="myresume-aside-uploadresume-subtitle">填写简历更轻松</p>
                  <p class="myresume-aside-uploadresume-desc">注：解析简历不能100%解析正确，请仔细核对您的简历后再保存</p>
                  <div class="myresume-aside-uploadresume-btn" @click="$router.push('/resumeoptimize?step=0')">
                    一键解析
                  </div>
              </div>
              <div class="myresume-aside-assets">
                  <el-dropdown style="width: 100%" @command="downloadAttAction" v-if="progress == 100">
                    <el-button :loading="downloadingStatus">{{downloadingStatus ? "下载中" : "下载简历"}}</el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="docx">
                        <img
                            style="width:12px;margin-right:5px;vertical-align: middle"
                            src="../../assets/images/word.png"/>word
                        </el-dropdown-item>
                        <el-dropdown-item command="pdf">
                        <img style="width:12px;margin-right:5px;vertical-align: middle" 
                             src="../../assets/images/pdf.png"/>pdf
                        </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-popover v-else
                    placement="bottom"
                    width="200"
                    trigger="hover"
                    popper-class="myresume-index-hover"
                    content="简历未完善，不能下载！">
                    <el-button class="myresume-index-btn-disabled" slot="reference">下载简历</el-button>
                  </el-popover>
              </div>
            </div>

            <div class="boxShadow resumeLogin">
              <img width="240px" src="../../assets/images/newicon/resumeLogin.jpg" />
            </div>


          </div>
           
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import { mapState, mapActions, mapGetters } from "vuex";
import { regular } from "../../libs/utilts";
import educationEdit from "./components/educationEdit.vue";
import jobExpectEdit from './components/jobExpectEdit.vue';
import wordEdit from "./components/workEdit.vue";
import projectEdit from "./components/projectkEdit.vue";
import defaultAvatar from "../../assets/images/144px.png";
import Search from '../../components/search.vue'
//import talentImg from '@/assets/images/talent/right.png';
import { getSystemImage } from '@/api/common'

export default {
  components: { educationEdit, wordEdit, projectEdit,Search,jobExpectEdit },
  data() {
    return {
      hrefList:[{id:1,href:"#baseinfo",title:"baseinfo",name:"基本信息"},
      {id:2,href:"#IndividualLabels",title:"IndividualLabels" ,name:"个人标签"},
  
      {id:3,href:"#selfEvaluation",title:"jobIntention" ,name:"自我评鉴"},
      {id:4,href:"#jobIntention",title:"jobIntention" ,name:"求职意向"},
      
      {id:5,href:"#workExperience",title:"workExperience" ,name:"工作经历"},
      {id:6,href:"#projectExperience",title:"projectExperience" ,name:"项目经验"},
      {id:7,href:"#educationalExperience",title:"educationalExperience" ,name:"教育经验"},
     
      ],
      fullloading:null,

      defaultAvatar,
      baseInfoEdit: false,
      ndividualLabels: [],
      ndividualLabelsiEdit: false,
      selfEvaluationEdit: false,
      jobIntentionEdit: false,
      attResumeList: [],
      personlabels: [],
      projectExperienceList: [],
      educationalBackgroundList: [],
      JobExpectateList:[],  //求职期望列表
      workExperienceList: [],

      educationalEdit: {0: false},
      JobExpectateEdit:{0:false}, //求职期望
      workEdit: {0: false},
      projectEdit: {0: false},

      offset: { top: 10, bottom: 0 },
      downloadingStatus: false,

      workEditStatus: "edit", // 工作经历添加编辑按钮
      projectEditStatus: "edit", // 项目经验添加编辑按钮
      educationalEditStatus: "edit", // 项目经历添加编辑按钮
      JobExpectateStatus: "edit", // 求职期望添加编辑按钮

      uploadProgress: 0,
      showUploadProgress: false,
      talentImg: '',
    };
  },
  async created() {
    this.getInitDate();
    this.getAccessoryResume();
    await this.getAllJob();
    await this.getPositionArea();
    getSystemImage(8).then(url=>this.talentImg = url);
  },
  computed: {
    ...mapState(["attachmentsUrl", "info", "detail"]),
    ...mapGetters([
      "gender",
      "qualificationsType",
      "currentState",
      "positionType",
      "qualificationsType",
      "salaryRange"
    ]),
    
    baseInforules() {
      const phoneReg = regular.phone;
      // 验证手机号码
      const validatorPhone =(rule, value, callback) => {
        if (!value) {
          return callback(new Error("用户名不能为空!!"));
        }
        if (!phoneReg.test(value)) {
          return callback(new Error("电话号码不符合规则"));
        } else {
          callback();
        }
      };
      return {
        jobSeekerName: [
          { required: true, trigger: "blur", message: "用户姓名必填" }
        ],
        phone: [
          { required: true, trigger: "change", validator: validatorPhone }
        ],
        gender: [{ required: true, trigger: "change", message: "性别必填" }],
        qualificationsType: [
          { required: true, trigger: "change", message: "学历必填" }
        ],
        graduateSchool: [
          { required: true, trigger: "change", message: "毕业学校必填" }
        ],
        majorSubjects: [
          { required: true, trigger: "change", message: "专业必填" }
        ],
        birthday: [
          { required: true, trigger: "blur", message: "出生年月必填" }
        ],
        currentAreaId: [
          { required: true, trigger: "blur", message: "所在城市必填" }
        ],
        jobSeekerWechatId: [
          { required: true, trigger: "blur", message: "微信号" }
        ],
        email: [{ required: true, trigger: "blur", message: "邮箱必填" }],
        currentCompany: [
          { required: true, trigger: "blur", message: "当前公司必填" }
        ],
        graduateDate: [
          { required: true, trigger: "blur", message: "毕业日期必填" }
        ],

        arriveDate: [
          { required: true, trigger: "blur", message: "到岗时间必填" }
        ],
        expectedCity: [
          { required: true, trigger: "blur", message: "期望城市必填" }
        ],
        positionName: [
          { required: true, trigger: "blur", message: "目前职位必填" }
        ],
        currentSalary: [
          { required: true, trigger: "blur", message: "目前薪水必填" }
        ],
        expectedPositionNames: [
          { required: true, trigger: "blur", message: "期望职位必填" }
        ]
      };
    },
    token() {
      return window.localStorage.getItem("token");
    },
    baseInfo: {
      get() {
        return this.$store.state.user.detail;
      },
      set(val) {
        return val;
      }
    },
    progress() {
      const p = Number(this.$store.state.user.info.progress);
      if (p === 0) return this.$router.push("/baseInfoAdd");
      return p;
    },
    pickerOptionsEnd() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      };
    }
  },
  methods: {
    ...mapActions([
      "getUserInfo",
      "accessoryResume",
      "deletAttResume",
      "downloadAtt",
      "getEducation",
      "getWorkExperience",
      "getProjectExperience",
      "modifyUserBaseInfo",
      "getMyLabels",
      "addLabels",
      "delEducation",
      "delWorkExperience",
      "delProjectExperience",
      "checkEmailAction",
      "emailVerify",
      "getSelfUserInfo",
      "getJobExpect",
      "delJobExpect",
      "getAllJob",   //所有职位
      "getPositionArea",


    ]),
    updateValue(data){
      this.$router.push({
        path:"/job",
        query:data
      })
    },
    async getInitDate() {
      await this.getUserInfoAction();
      const edu = await this.getEducation();
      const work = await this.getWorkExperience();
      const project = await this.getProjectExperience();
      const myLabels = await this.getMyLabels();
      const expect = await this.getJobExpect();

      this.setEdit(edu.data, work.data, project.data,expect.data);

      this.educationalBackgroundList = edu.data || [];
      this.projectExperienceList = project.data || [];
      this.workExperienceList = work.data || [];
      this.personlabels = myLabels.data || [];
      this.JobExpectateList = expect.data || [];  //求职期望数据列表

      if (this.$route.query.isEdit === "1") {
        this.baseInfoEditAction();
      } else if (this.$route.query.isEdit === "2") {
        this.jobIntentionEditAction();
      } else if (this.$route.query.isEdit === "3") {
        this.resetEdit();
        this.selfEvaluationEdit = true;
      } else if (this.$route.query.isEdit === "4") {
        if (this.$route.query.id) {
          let index = this.educationalBackgroundList.findIndex(
            item => item.id == this.$route.query.id
          );
          this.changeEditStatu("educationalEdit", index);
        } else {
          this.addEducationalBackgroundList("new");
        }
      } else if (this.$route.query.isEdit === "5") {
        if (this.$route.query.id) {
          let index = this.workExperienceList.findIndex(
            item => item.id == this.$route.query.id
          );
          this.changeEditStatu("workEdit", index);
        } else {
          this.addWorkExperienceList("new");
        }
      } else if (this.$route.query.isEdit === "6") {
        if (this.$route.query.id) {
          let index = this.projectExperienceList.findIndex(
            item => item.id == this.$route.query.id
          );
          this.changeEditStatu("projectEdit", index);
        } else {
          this.addProjectExperienceList("new");
        }
      }else if (this.$route.query.isEdit === "7") {
        if (this.$route.query.id) {
          let index = this.JobExpectateList.findIndex(
            item => item.id == this.$route.query.id
          );
          this.changeEditStatu("JobExpectateEdit", index);
        } else {
          this.addJobExpectList("new");
        }
      }
    },
    setNewEdit(key, item) {
      for (let i = 0; i < item; i++) {
        this.$set(this[key], i, false);
      }
    },
    setEdit(edu = [], work = [], project = [],jobExpe=[]) {
      const obj = {
        educationalEdit: edu.length,
        workEdit: work.length,
        projectEdit: project.length,
        JobExpectateEdit: jobExpe.length,

      };
      for (const key in obj) {
        const item = obj[key];
        for (let i = 0; i < item; i++) {
          this.$set(this[key], i, false);
        }
      }
    },
    async getUserInfoAction() {
      await this.getUserInfo();
      this.ndividualLabels = this.$store.state.user.detail.labels || [];
    },
    handleAvatarSuccess({ data }) {
      this.baseInfo.imageUrl = data[0];
    },
    beforeAvatarUpload() {},
    choosePersonLabels({ value }) {
      if (this.ndividualLabels.indexOf(value) > -1) {
        return this.$message.error("已经选择了这个标签");
      }
      if (this.ndividualLabels.length > 2) {
        return this.$message.error("最多只支持定义3个标签");
      }
      this.ndividualLabels.push(value);
    },
    baseInfoEditAction() {
      this.resetEdit();
      this.baseInfoEdit = true;
      this.baseInfo = this.$store.state.user.info || {};
    },
    async cancelBaseInfoEdit() {
      //取消个人信息编辑
      this.baseInfoEdit = false;
      await this.getUserInfoAction();
    },
    resetEditStatus() {
      this.baseInfoEdit = false;
      this.ndividualLabelsiEdit = false;
      this.selfEvaluationEdit = false;
      this.jobIntentionEdit = false;
      // this.JobExpectateEdit = false;
    },
    async getAccessoryResume() {
      const { data } = await this.accessoryResume();
      this.attResumeList = data;
      // this.attResumeList=[{id:1,fileName:"我的简历"}]
    },
    async deleteAttReume(id) {
      const res = await this.deletAttResume(id);
      if (res) {
        this.getAccessoryResume();
        this.$message.success("删除成功");
      }
    },
    downloadAttAction(formate) {
      this.downloadingStatus = true;
      this.downloadAtt(formate).then(res => {
        const blob = res;
        var binaryData = [];
        binaryData.push(blob);
        let aLink = document.createElement("a");
        let href = window.URL.createObjectURL(
          new Blob(binaryData, { type: `application/${formate}` })
        ); //创建下载的链接
        aLink.href = href;
        aLink.download =
          this.baseInfo.jobSeekerName +
          "-" +
          this.baseInfo.phone +
          "-" +
          this.baseInfo.positionName +
          `.${formate}`;
        document.body.appendChild(aLink);
        aLink.click(); //点击下载
        document.body.removeChild(aLink); //下载完成移除元素
        this.downloadingStatus = false;
      });
    },
    async uploadResumeAction(res) {
      console.log("====", res);

      if (res) {
        const { code, message } = await this.accessoryResume();
        await this.getAccessoryResume();
        this.showUploadProgress = false;
        
        this.uploadProgress = 0;
        if (res.code == 200){
          this.fullloading.close();
          return this.$message.success("上传成功");
        } 
        if (res.code === 95070) {
          this.$confirm(res.message, "提示", {
            cancelButtonText: "放弃内推",
            confirmButtonText: "立即添加",
            type: "warning"
          }).then(confirm => {
            if (confirm) {
              this.baseInfoEditAction();
            }
          });
          return false;
        }

        this.$message.error(res.message);
      }
    },
    async modifyBaseInfo() {
      const validate = await this.$refs["baseInfo"].validate();
      if (!validate) return;
      // const res = await  this.modifyUserBaseInfo(this.baseInfo);
      const res = await this.modifyUserBaseInfo({
        birthday: this.baseInfo.birthday,
        email: this.baseInfo.email,
        esId: this.baseInfo.esId || null,
        jobSeekerName: this.baseInfo.jobSeekerName,
        jobSeekerWechatId: this.baseInfo.jobSeekerWechatId,
        phone: this.baseInfo.phone,
        currentAreaId: this.baseInfo.currentAreaId,
        gender: this.baseInfo.gender,
        qualificationsType: this.baseInfo.qualificationsType,
        imageUrl: this.baseInfo.imageUrl,
        graduateDate: this.baseInfo.graduateDate,
        graduateSchool: this.baseInfo.graduateSchool,
        currentCompany: this.baseInfo.currentCompany,
        majorSubjects: this.baseInfo.majorSubjects,
        positionName: this.baseInfo.positionName
      });
      if (res.code === 200) {
        this.$message.success("修改成功");
        this.getUserInfo();
        this.baseInfoEdit = false;
      } else {
        this.$message.error(res.message);
      }
    },
    async addLabelsAction() {
      const data = {
        userLabel: [],
        userLabelValue: [],
        userDefindLabel: []
      };
      const labels = this.ndividualLabels;
      const personlabels = this.personlabels;
      for (const item in labels) {
        for (const n in personlabels) {
          if (labels[item] === personlabels[n].value) {
            data.userLabel.push(personlabels[n].code);
            data.userLabelValue.push(personlabels[n].value);
          }
        }
      }
      data.userDefindLabel = labels.filter(
        item => !data.userLabelValue.includes(item)
      );
      this.addLabels({
        userLabel: data.userLabel,
        userDefindLabel: data.userDefindLabel
      }).then(res => {
        this.$message.success("修改成功");
        this.ndividualLabelsiEdit = false;
      });
    },
    ndividualLabelsCancel() {
      this.ndividualLabelsiEdit = false;
      this.getUserInfoAction();
    },
    async cancelSelfEvaluationEdit() {
      //取消自我评价
      await this.getUserInfoAction();
      this.selfEvaluationEdit = false;
    },
    async cancelJobIntentionEdit() {
      //取消求职意向
      await this.getUserInfoAction();
      this.resetEdit();
      this.jobIntentionEdit = false;
    },
    jobIntentionEditAction() {
      this.resetEditStatus();
      this.jobIntentionEdit = true;
    },
    async modiySelfEvaluation() {
      const validate = this.baseInfo.personalAdvantage;
      if (!validate) return;
      const res = await this.modifyUserBaseInfo({
        personalAdvantage: this.baseInfo.personalAdvantage
      });
      if (res.code === 200) {
        this.$message.success("修改成功");
        this.selfEvaluationEdit = false;
        this.getUserInfoAction();
      } else {
        this.$message.error(res.message);
      }
    },
    async jobIntentionSubmitAction() {
      const validate = await this.$refs["jobIntention"].validate();
      if (!validate) return;
      const {
        arriveDate,
        currentSalary,
        currentState,
        expectedCity,
        expectedPositionNames,
        expectedPositionType,
        expectedSalaryRange,
        positionName
      } = this.baseInfo;
      const res = await this.modifyUserBaseInfo({
        arriveDate,
        currentSalary,
        currentState,
        expectedCity,
        expectedPositionNames,
        expectedPositionType,
        expectedSalaryRange,
        positionName
      });
      if (res.code === 200) {
        await this.getUserInfo();
        this.$message.success("修改成功");
        this.jobIntentionEdit = false;
        this.resetEditStatus();
        this.getUserInfo();
      } else {
        this.$message.error(res.message);
      }
    },
    //添加工作经验
    async addWorkExperienceList(type) {
      if (type === "new") {
        this.workExperienceList.push({});
      } else {
        this.workExperienceList[0] = {};
      }
      let index = this.workExperienceList.length - 1;
      this.changeEditStatu("workEdit", index);
      this.workEditStatus = "add";
    },
    //编辑工作经验
    async workEditSuc() {
      // 刷新用户信息
      await this.getUserInfo();
      //跳过/取消工作经历编辑
      const work = await this.getWorkExperience();
      this.workExperienceList = work.data || [];
      this.resetEdit("workEdit");
      this.setNewEdit("workEdit", work.data.length);
    },
    //添加项目经验
    async addProjectExperienceList(type) {
      if (type === "new") {
        this.projectExperienceList.push({});
      } else {
        this.projectExperienceList[0] = {};
      }
      let index = this.projectExperienceList.length - 1;
      this.changeEditStatu("projectEdit", index);
      this.projectEditStatus = "add";
    },
    async projectEditSuc() {
      // 刷新用户信息
      await this.getUserInfo();
      //跳过/取消项目经验
      const project = await this.getProjectExperience();
      this.projectExperienceList = project.data || [];
      this.resetEdit("projectEdit");
      this.setNewEdit("projectEdit", project.data.length);
    },

    //添加教育经验
    async addEducationalBackgroundList(type) {
      if (type === "new") {
        this.educationalBackgroundList.push({});
      } else {
        this.educationalBackgroundList[0] = {};
      }
      let index = this.educationalBackgroundList.length - 1;
      this.changeEditStatu("educationalEdit", index);
      this.educationalEditStatus = "add";
    },
    async educationEditSuc() {
      // 刷新用户信息
      await this.getUserInfo();
      //跳过/取消教育经验
      const edu = await this.getEducation();
      this.educationalBackgroundList = edu.data || [];
      this.resetEdit("educationalEdit");
      this.setNewEdit("educationalEdit", edu.data.length);
    },
    
     //添加求职期望
    async addJobExpectList(type) {
      if (type === "new") {
        this.JobExpectateList.push({});
      }else {
        this.JobExpectateList[0] = {};
      }
      let index = this.JobExpectateList.length - 1;
      this.changeEditStatu("JobExpectateEdit", index);
      this.JobExpectateStatus = "add";
    },


    async jobExpectEditSuc() {
      // 刷新用户信息
      await this.getUserInfo();
      //跳过/取消教育经验
      const expect = await this.getJobExpect();  
      this.JobExpectateList = expect.data || [];
      this.resetEdit("JobExpectateEdit");
      this.setNewEdit("JobExpectateEdit", expect.data.length);
    },

    resetEdit(type) {
      this.resetEditStatus();
      const arr = ["educationalEdit", "workEdit", "projectEdit","JobExpectateEdit"];
      for (const n in arr) {
        const key = arr[n];
        for (const i in Object.keys(this[key])) {
          const item = Object.keys(this[key])[i];
          this[key][item] = false;
        }
      }
    },
    changeEditStatu(type, index) {
      // 刷新用户信息
      this.getUserInfo();
      this.workEditStatus = "edit";
      this.projectEditStatus = "edit";
      this.educationalEditStatus = "edit";
      this.JobExpectateStatus = "edit";

      this.resetEdit(type);
      this[type][index] = true;
    },
    async checkEmail() {
      await this.checkEmailAction(this.baseInfo.email);
      this.$prompt("请输入邮箱收到的验证码(5分钟有效)", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^[0-9]+$/,
        inputErrorMessage: "验证码格式不对"
      }).then(async ({ value }) => {
        const email = this.baseInfo.email;
        const captcha = value;
        const res = await this.emailVerify({ email, captcha });
        if (res.code !== 200) {
          return this.$message.error(res.message);
        }
        await this.getUserInfoAction();
        return this.$message.success("邮箱验证成功！");
      });
    },
    async deleteItem(type, id) {
      // 刷新用户信息
      await this.getUserInfo();
      const action = this[type];
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        const res = await action(id);
        if (res) {
          this.getInitDate();
          return this.$message.success("删除成功");
        }
      });
    },
    // uploadResumeProgress
    uploadResumeProgress() {
      this.showUploadProgress = true;
      this.addUploadProgress();
    },
    beforeUploadAction(){
      this.fullloading = this.$loading({
        lock: true,
        text: "附件简历上传中...,请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    // 添加附件简历进度条
    addUploadProgress() {
      let inter = setInterval(() => {
        if (this.uploadProgress >= 98) {
          clearInterval(inter);
          return;
        } else {
          this.uploadProgress++;
        }
      }, 200);
    },
    // 未完善基本信息时给出提示
    basicInfoTips() {
      this.$confirm(
        "你还没有添加基本信息，为了高效的内推，请先添加基本信息",
        "提示",
        {
          confirmButtonText: "立即添加",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(async () => {
        this.baseInfoEditAction();
      });
    },
    dateChange(date) {
      // 这里的回调就是需要的数据
      console.log(date)
    }
  }
};
</script>

<style lang="less" rel="stylesheet/less">

.myresume-box{
  background: linear-gradient(360deg, #F9FBFF 0%, #DCEAFF 100%);
  padding-top: 20px;
    .myresume {
      margin-top: 20px;
      &-search{
        margin-bottom: 10px;
        .mian-contents{
          width: 1079px;
        }
        .weichat{
          width: 160px;
          height: 46px;
          margin-left: 40px;
          background: #fff;
          padding: 2px;
          justify-content: flex-end;
          align-items: flex-end;
          position: relative;
          p{
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            padding-right: 20px;
          }
          img{
            width: 40px;
            height: 40px;
            background-color: #000;
            margin:0 8px 0 10px;
          }
          .lines{
            position: absolute;
            top: 0;
            right: 58px;
            width: 1px ;
            height: 46px;
            background: rgba(0,0,0,0.1);
            // background-color: red;
          }
        }
      }
      .el-select {
        width: 100%;
      }
      .sidebar-menu {
        width: 230px;
        float: right;
      }
      &-wraper {
        width: 1280px;
        margin: 0 auto;
        align-items: flex-start;
        // position: relative;
        // .affix {
        //   position: fixed;
        //   left: 50%;
        //   margin-left: 370px;
        //   top: 0;
        // }
        // .affix-bottom {
        //   position: absolute;
        //   right: 0;
        // }
      }
      &-attdownload {
        display: flex;
        a {
          padding: 20px;
          border: 1px solid #fff;
          &:hover {
            border: 1px solid #2f74ff;
          }
        }
        img {
          width: 155px;
        }
      }
      &-main {
        background-color: #fff;
        // float: left;
        box-sizing: border-box;
        width: 800px;
        padding: 24px;
        margin-bottom: 30px;
        &-title {
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            text-align: left;
            border-bottom:  1px solid  #EBEBEB;
            padding-bottom: 16px;

        }
      }
      &-aside {
        background-color: #fff;
        // float: right;
        width: 240px;
        box-sizing: border-box;
        padding: 15px;
        // position: sticky;
        top:66px;
        &-uploadresume {
          &-title{
            align-items: center;
            padding-bottom: 6px;
            img{
              width: 20px;
              height: 20px;
              margin-right: 8px;
            }
            p{
              font-size: 18px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #333333;
            }
          }
          &-subtitle{
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 20px;
            padding-bottom: 4px;
            text-align: left;
          }
          &-desc {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0,0,0,0.45);
            line-height: 20px;
            padding: 0 10px 10px 0;
            text-align: left;
          }
          &-btn{
            height: 32px;
            line-height: 30px;
            box-shadow: 0px 8px 24px -6px rgba(40,124,243,0.2);
            border-radius: 6px;
            border: 1px solid #287CF3;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #287CF3;
            text-align: center;
            cursor: pointer;
            transition: all .2s linear;
            &:hover{
              background: rgba(40,124,243,0.1);
            }
          }
          border-bottom: 1px solid #f4f4f4;
        }
        &-assets {
          .el-button {
            border: solid 1px #287CF3;
            width: 100%;
            margin: 15px 0 0 0;
            color: #287CF3;
            border-radius: 6px;
            height: 32px;
            font-weight: 400;
            line-height: .5 !important;
          }
        }
        &-progress {
          padding: 16px 0 4px 16px;
          &-text {
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            margin-bottom: 10px;
          }
          border-bottom: 1px solid #f4f4f4;
          .el-progress-bar__inner {
            &:before {
              content: "";
              opacity: 0;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: #fff;
              border-radius: 10px;
              animation: progress-active 2s ease-in-out infinite;
            }
          }
        }
        &-stepmenu {
          list-style: none;
        //   margin-top: 10px;
          .scrollactive-item {
            font-size: 16px;
            line-height: 3;
            display: block;
            text-align: left;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0,0,0,0.65);
            position: relative;
            padding-left: 16px;
            &:hover {
              color: rgba(0,0,0,0.85);;
            }
            &.is-active {
                // color: #287CF3;
                color: rgba(0,0,0,0.85);;
                font-weight: 500;
                background: #F6F9FC;
            //   &::after {
            //     content: "";
            //     display: block;
            //     width: 4px;
            //     height: 0.9em;
            //     position: absolute;
            //     left: 50px;
            //     top: 17px;
            //     background-color: #049cfd;
            //   }
            }
          }
        }
        &-attachement {
          .el-upload.el-upload--text {
            width: 100%;
          }
          &_title {
            font-size: 14px;
            border-bottom: 1px solid  #EBEBEB;
            padding-bottom: 10px;
          }
          &_item {
            font-size: 12px;
            line-height: 2;
            display: flex;
            width: 100%;
            align-items: center;
            padding-top: 6px;
            a{
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }


          }
          &_list{
            padding-top: 6px;
          }
        }
      }
      &-directory{
        padding: 0;
        position: sticky;
      }
      &-content {
        &-ls {
          position: relative;
          cursor: pointer;

          .edit-tools {
            display: none;
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
            right: 20px;
            i {
              font-size: 20px;
              margin-left: 10px;
              cursor: pointer;
              &:hover {
                color: #2f74ff;
              }
            }
          }
          &:hover {
            display: block;
            /*border: 1px dashed #2f74ff;*/
            .edit-tools {
              display: block;
            }
          }
          margin-bottom: 20px;
          line-height: 2;
          ol {
            padding: 0;
            margin: 0;
          }
          h2 {
            font-size: 14px;
          }
          h3 {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0,0,0,0.85);
            line-height: 24px;
            padding-right: 4px;
          }
          &_content {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(0,0,0,0.85);
            line-height: 24px;
            padding-right: 100px;
            ol li {
              margin-left: 14px;
            }
          }
          &_stitle {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0,0,0,0.85);
            .jobExpectText{
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0,0,0,0.75);
              line-height: 24px;

            }
          }
          &_title {
            font-size: 14px !important;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0,0,0,0.85);
            span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0,0,0,0.45);
              margin-left: 20px;
            }
          }
        }
        &-item {
          &-title {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0,0,0,0.85);
            margin: 20px 0;
            &.border-left {
              position: relative;
            //   padding-left: 12px;
            //   &:after {
            //     display: block;
            //     content: "";
            //     position: absolute;
            //     height: 14px;
            //     border-left: 2px solid #049cfd;
            //     top: 6px;
            //     left: 0;
            //   }
            }
            .base{
             
                .el-icon-success{
                    color: #287CF3;
                }
                
            }
            .edit {
              float: right;
              color: #287CF3;
              font-size: 14px;
              cursor: pointer;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
       
      }
      &-baseinfo {
        &-item {
          padding: 0 12px;
          color: #666666;
          margin-bottom: 10px;
          &-seekerName{
            font-size: 16px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: rgba(0,0,0,0.85);
            line-height: 22px;
          }
          
          span {
            padding: 0 10px;
          }
          &.info {
            
            a{
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(0,0,0,0.85);
              line-height: 20px;
            }
            .fonticon {
              // background-color: #f5f5f5;
              // border-radius: 50%;
              font-size: 14px;
              // padding: 2px;
              margin-right: 4px;
              // color: #999999;
            }
            .el-divider--vertical{
              margin: 0 16px;
            }
          }
          &.name {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(0,0,0,0.85);
            line-height: 16px;
            .fonticon {
              background-color: #ff5555;
              font-size: 12px;
              padding: 2px;
              margin-left: 5px;
              margin-top: -2px;
              color: #fff;
            }
          }
        }
        &-right {
          
          .avatar {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            // padding: 5px;
            border: 1px solid #ddd;
          }
        }
        .myresume-form{
            background: #F2F6FA;
            border-radius: 6px;
            padding: 24px;
        }
      }
      &-edit {
        background-color: #ebf5fb;
        border: dashed 1px #287CF3;
        color: #287CF3;
        height: 40px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        &-content {
          margin-right: -10px;
          .el-input__suffix {
            display: none;
          }
          .el-tag {
            border-radius: 14px;
            background-color: #287CF3;
            margin-right: 10px;
            color: #fff;
          }
          .el-select .el-tag__close.el-icon-close {
            background: transparent;
            color: #fff;
          }
          .el-select {
            width: 100%;
          }
        }
        &:hover {
          border-color: #1e88e5;
        }
      }
      .bottomBorder{
        padding-bottom: 20px;
        border-bottom: 1px solid #EBEBEB;
      }
      .hasBg{
        background: #F2F6FA;
        border-radius: 6px;
        padding: 24px;
      }
    }
    .person-labels-sets {
        background: #F2F6FA;
            border-radius: 6px;
            padding: 24px;
           margin-top: 16px;
      li {
        list-style: none;
        float: left;
        padding: 10px 20px 10px 0;
        cursor: pointer;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0,0,0,0.85);
        font-size: 14px;
        &:hover {
          color: #287CF3;
        }
      }
    }
    .person-labels {
      display: none;
    }
    .el-progress-bar {
      padding: 0;
      margin: 0;
    }
    .myresume-index-btn-disabled:hover {
      color: #c0c4cc;
      cursor: not-allowed;
      background-image: none;
      background-color: #fff;
      border-color: #ebeef5;
    }
    .myresume-index-hover {
      color: #dd6161;
    }
    .resumeLogin{
      margin-top: 20px;
      overflow: hidden;
      line-height: 0;
    }
    @keyframes progress-active {
      0% {
        opacity: 0.3;
        width: 0;
      }
      to {
        opacity: 0;
        width: 100%;
      }
    }
    .avatar-edit {
      .avatar {
        // width: 135px;
        height: 135px;
        padding: 5px;
        border: 1px solid #ddd;
      }
      .avatar-title{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0,0,0,0.85);
      }
      .avatar-uploader {
        position: relative;
        .el-upload {
          position: relative;
        }
        .fonticon {
          display: none;
        }
        &:hover {
          .avatar {
            opacity: 0.7;
          }
          .fonticon {
            display: inline;
            font-size: 48px;
            color: #fff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
    }
}
</style>
